import useApi from '../../../api/useApi';
import { CategoryGet, SubCategoryByAdminGetDetail } from '../../../api/orgService';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { TextField, MenuItem, CircularProgress, Grid } from "@mui/material";

function SubCategorySelect({setCategoryId,setSubCategoryId}) {
    const { request: getAllSubCategoriesByAdmin, data: subCategoryByAdminData, error: subCategoryByAdminError,loading: categoryLoading} = useApi(SubCategoryByAdminGetDetail);
    const { request: getAllCategories, data:categoryData, error:categoryError} = useApi(CategoryGet);

    const [selectedSubcategory, setSelectedSubcategory] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [data, setData] = useState([])

    useEffect(() => {
        // partnerGetAll();
        getAllSubCategoriesByAdmin()
        getAllCategories()
            // eslint-disable-next-line
    }, []);

    useEffect(()=>{
        if(subCategoryByAdminError){
            toast.error(`${JSON.stringify(subCategoryByAdminError?.response?.data,null,2)}`,{position: "top-center"});
        }
    },[subCategoryByAdminError])

    useEffect(()=>{
        if(subCategoryByAdminError){
            toast.error(`${JSON.stringify(subCategoryByAdminError?.response?.data,null,2)}`,{position: "top-center"});
        }
    },[subCategoryByAdminError])

    useEffect(() => {
        // console.log(subCategoryByAdminData)
        if(subCategoryByAdminData?.data){
        setData(subCategoryByAdminData?.data)
        }
        // eslint-disable-next-line
    }, [subCategoryByAdminData]);

    const handleSubcategoryChange = (e) => {
        e.preventDefault()
        console.log("e: ",e)
        let subId = e.target.value;
        setSelectedSubcategory(e.target.value);
        
        if(setSubCategoryId){

            setSubCategoryId(subId)
        }
        // find the category for this subcategory
        let sub = data.find((item) => item.id === subId);
        if (sub) {
          setSelectedCategory(sub.category.id);
        } else {
          setSelectedCategory("");
        }

        if(setCategoryId){
            setCategoryId(sub.category.id)
        }
      };


  return (
    <Grid container spacing={2} style={{ width: "100%" }}>
      {/* Subcategory Select */}
      <Grid item xs={12} sm={6} style={{ width: "40%" }}>
      <TextField
        select
        fullWidth
        fluid
        label="Category"
        name="category"
        value={selectedCategory}
        onChange={() => {}} // disabled — handled automatically
        variant="outlined"
        helperText="This category auto-fills based on the subcategory"
        disabled
        sx={{ mt: 2 }}
      >
        {/* derive unique categories from data */}
        {[...new Map(data.map((d) => [d.category.id, d.category])).values()].map(
          (cat) => (
            <MenuItem key={cat.id} value={cat.id}>
              {cat.name}
            </MenuItem>
          )
        )}
      </TextField>
      </Grid>

      {/* Category Auto-filled */}
      <Grid item xs={12} sm={6} style={{ width: "40%" }}>
        {/* Subcategory Select */}
      <TextField
        select
        fullWidth
        fluid
        label="Select Subcategory"
        name="subcategory"
        value={selectedSubcategory}
        onChange={handleSubcategoryChange}
        variant="outlined"
        helperText="Choose a subcategory"
        disabled={categoryLoading}
        sx={{ mt: 2 }}
      >
        <MenuItem key="unique-key-#2345678"value={0} default>
             -- Select a Subcategory --
        </MenuItem>
        {categoryLoading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : (
          data.map((sub) => (
            <MenuItem key={sub.id} value={sub.id}>
              {sub.name}
            </MenuItem>
          ))
        )}
      </TextField>
      
      </Grid>
      </Grid>
  )
}

export default SubCategorySelect